import EntityManager from '@/pages/admin/components/EntityManager';
import { eventFields, eventColumns } from '@/pages/admin/entityConfigs';

export default function EventsPage() {
  return (
    <EntityManager
      table="events"
      fields={eventFields}
      columns={eventColumns}
      orderBy="event_date"
      searchKeys={['title', 'location', 'organizer']}
      addLabel="Add Event"
    />
  );
}